import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        status: '',
        token: localStorage.getItem('token') || '',
        user : JSON.parse(localStorage.getItem('user')) || '',
        texts: []
    },
    mutations: {
        auth_request(state){
            state.status = 'loading'
        },
        auth_success(state, payload){
            state.status = 'success';
            state.token = payload.token;
            state.user = payload.user;
        },
        auth_error(state){
            state.status = 'error'
        },
        logout(state){
            state.status = '';
            state.token = ''
        },
        loadTexts(state, data) {
            state.texts = data;
        },
    },
    actions: {
        login({commit}, user){
            return new Promise((resolve, reject) => {
                commit('auth_request');

                axios({url: process.env.VUE_APP_SERVER+'users/login.php',
                    headers: { 'content-type': 'application/x-www-form-urlencoded' },
                    data: user,
                    method: 'POST' })
                    .then(response => {

                        const token = response.data.jwt;
                        const user = response.data.data.user;

                        localStorage.setItem('token', token);
                        localStorage.setItem('user', JSON.stringify(user));
                        axios.defaults.headers.common['Authorization'] = token;
                        commit('auth_success', {
                            token: token,
                            user: user
                        });
                        resolve(response)

                    })
                    .catch(err => {
                        commit('auth_error', err);
                        localStorage.removeItem('token');
                        reject(err);
                    })
            })
        },
        register({commit}, user){
            return new Promise((resolve, reject) => {
                commit('auth_request');

                axios({url: process.env.VUE_APP_SERVER+'users/registration.php',
                    headers: { 'content-type': 'application/x-www-form-urlencoded' },
                    data: user,
                    method: 'POST' })
                    .then(response => {

                        const token = response.data.jwt;
                        const user = response.data.data.user;

                        localStorage.setItem('token', token);
                        axios.defaults.headers.common['Authorization'] = token;
                        commit('auth_success', {
                            token: token,
                            user: user
                        });
                        resolve(response)
                    })
                    .catch(err => {
                        commit('auth_error', err);
                        localStorage.removeItem('token');
                        reject(err)
                    })
            })
        },
        logout({commit}){
            return new Promise((resolve, reject) => {
                commit('logout');
                localStorage.removeItem('token');
                delete axios.defaults.headers.common['Authorization'];
                resolve();
                console.log(reject);
            })
        },
        loadDataTexts({commit}){
            axios({
                url: process.env.VUE_APP_SERVER + 'texts/list.php',
                headers: { 'content-type': 'application/x-www-form-urlencoded' },
                data: this.data,
                method: 'GET'
            })
            .then((response) => {
                commit('loadTexts', response.data.records);
            })
        },
    },
    getters : {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
        user: state => state.user,
        texts: state => state.texts,
        isAdmin: state => {
            return (state.user.permission === 'admin');
        }
    }
})